import React, { useState, useEffect } from "react";
import { useQuery } from "react-query";
import { fetchClient } from "../shared/api/fetching";
import Dropdown from "../shared/components/Dropdown";
import ErrorDisplay from "../shared/components/ErrorDisplay";
import { getPureClubsData } from "../shared/utils";
import { apiURL, mlsClubsAPI } from "../shared/api/variables";
import PlayersRosterTableWrapper from "./components/PlayersRosterTableWrapper";
import { useReactAppState } from "../shared/containers/utils";
import { getDefaultCompetitionSportecId } from "../shared/api/variables";
function PlayersHubRoster({ options }) {
  const { t } = useReactAppState();

  const seasonSportecId = options?.competitionSeason;
  const competitionSportecId = getDefaultCompetitionSportecId();

  const [currentClub, setCurrentClub] = useState("");
  const [clubSportecId, setClubSportecId] = useState("");
  const playerClub = options?.playerClub;

  const clubsEndpoint = mlsClubsAPI({ competitionSportecId, seasonSportecId });

  const {
    isLoading: isLoadingClubs,
    isError: isErrorClubs,
    data: clubsData,
    error: clubsError,
    isIdle: isIdleClubs,
  } = useQuery({
    queryKey: [`mls-clubs`, {competitionSportecId, seasonSportecId }],
    queryFn: () =>
      fetchClient({
        ...options,
        endpoint: clubsEndpoint,
        apiURL: apiURL.statsAPI,
      }),
    select: (data) => data?.clubs,
    notifyOnChangeProps: ["data", "error"],
  });

  if (clubsData && playerClub && !currentClub) {
    const preSelectedClub = clubsData?.find(
      (club) => club?.club_id === playerClub?.fields?.sportecId
    );
    if (preSelectedClub && preSelectedClub?.club_name) {
      setCurrentClub(preSelectedClub?.club_name);
    }
  }

  useEffect(() => {
    if (currentClub) {
      const clubId = clubsData?.find(
        (club) => currentClub === club.club_name
      )?.club_id;

      if (clubId) {
        setClubSportecId(clubId);
      }
    }
  }, [currentClub]);

  return (
    <div role="region" className="mls-c-players-hub-roster">
      <div className="mls-c-stats__dropdown-group">
        {clubsData?.length && currentClub && playerClub ? (
          <Dropdown
            onChangeFn={(val) => setCurrentClub(val)}
            items={getPureClubsData(clubsData)}
            currentValue={currentClub}
          />
        ) : isLoadingClubs || isIdleClubs ? (
          <label className="mls-o-buttons__dropdown-button mls-o-buttons__dropdown-button--label mls-o-buttons__dropdown-button--right ">
            <span className="mls-o-buttons__dropdown-label">{t("club")}</span>
            <select>
              <option className="mls-o-buttons__dropdown-item" value="loading">
                {t("loading")}
              </option>
            </select>
          </label>
        ) : isErrorClubs ? (
          <ErrorDisplay error={clubsError} />
        ) : (
          <></>
        )}
      </div>
      {clubSportecId ? (
        <PlayersRosterTableWrapper
          linkRulePath={options?.linkRulePath}
          clubOptaId={clubSportecId}
        />
      ) : (
        <></>
      )}
    </div>
  );
}

// eslint-disable-next-line no-func-assign
PlayersHubRoster = React.memo(PlayersHubRoster);

export default PlayersHubRoster;
